<template>
  <div>
    <!-- Modal -->
    <ModalCrud
      ref="modal"
      :grande="modalGrande"
      :permiteEliminar="PermiteEliminar"
      :titulo="TituloModal"
      :facade="facade"
      v-on:evento-eliminar="eliminado($event)"
      v-on:evento-guardar="guardado($event)"
      v-on:on-saving-error="errorGuardado($event)"
    >
      <template slot="titulo">
        <slot name="modalTitulo"></slot>
      </template>
      <template v-slot:default="propsModal">
        <!-- Acciones extra dentro del modal -->
        <slot class="accion" name="accion"></slot>
        <!-- Insertar el contenido dentro del modal -->
        <slot name="modalCuerpo" :item="propsModal.item"></slot>
      </template>
    </ModalCrud>

    <!-- Acciones -->
    <div class="acciones-panel">
      <button
        v-if="PermiteAgregar"
        @click="clickAgregar()"
        type="button"
        class="btn btn-success"
      >
        <span>Nuevo</span>
        <font-awesome-icon class="icono-derecha" :icon="Icons.AGREGAR" />
      </button>

      <Buscador :esBeneficio="true" :onSearch="filtrarTabla"></Buscador>
    </div>
    <!-- Tabla -->
    <Tabla
      ref="tabla"
      :columnas="columnas"
      :facade="facade"
      v-on:evento-item-elegido="clickItem($event)"
      v-on:lista-cargada="listaCargada"
    >
    </Tabla>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";
import { Icons as IconConstants } from "../../constants";
import ModalCrud from "./modals/ModalCrud";
import Tabla from "./tablas/Tabla";
import Buscador from "../panel/tablas/util/Buscador.vue";

const EVENTO_LISTA_CARGADA = "lista-cargada";

export default {
  components: {
    FontAwesomeIcon,
    Buscador,
    ModalCrud,
    Tabla,
  },
  props: {
    /** Columnas que se mostrarán en la tabla */
    columnas: Array,
    /** Si se quiere un modal grande */
    modalGrande: Boolean,
    /** Indica si se permite agregar una entidad */
    permiteAgregar: {
      type: Boolean,
      default: true,
    },
    /** Indica si se permite eliminar una entidad */
    permiteEliminar: {
      type: Boolean,
      default: true,
    },
    /** Fachada usada para cargar y guardar datos */
    facade: Function,
    titulo: String,
    tituloModal: String,
  },
  computed: {
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
    /** Item abierto en modal */
    Item() {
      return this.$refs.modal.item;
    },
    PermiteAgregar() {
      return this.permiteAgregar;
    },
    PermiteEliminar() {
      return this.permiteEliminar;
    },
    Titulo() {
      return this.titulo;
    },
    TituloModal() {
      return this.tituloModal;
    },
  },
  methods: {
    clickAgregar() {
      // Se abre el modal sin ningún item (modo creación)
      this.$refs.modal.abrir();
    },
    clickEditar(item) {
      // Se abre el modal con un item (modo edición)
      this.$refs.modal.abrir(item);
    },
    // Cuando se hace click en un item, se abrirá para editar
    clickItem(item) {
      this.clickEditar(item);
    },
    eliminado(item) {
      this.$refs.tabla.eliminado(item);
    },
    guardado(item) {
       Swal.fire({
                  icon: 'success',
                  title: 'Confirmación',
                  text: 'Se guardó correctamente!'
                  })

      this.$refs.tabla.guardado(item);
    },
    errorGuardado(){
      Swal.fire({
        icon: 'error',
        title: 'Problemas',
        text: 'No se pudo guardar!'
        })
    },
    listaCargada(lista) {
      this.$emit(EVENTO_LISTA_CARGADA, lista);
    },
    /** Muestra el modal y no aplica lógica extra */
    mostrarModalSinLimpiar() {
      this.$refs.modal.mostrarSinLimpiar();
    },
    /** Oculta el modal y no aplica lógica extra */
    ocultarModalSinLimpiar() {
      this.$refs.modal.ocultarSinLimpiar();
    },
    // Filtra la tabla segun la busqueda
    filtrarTabla(busqueda) {
      this.busqueda = busqueda;
      this.$refs.tabla.EventoRecargar(busqueda);
    }
  },
};
</script>

<style lang="scss" scoped>
.acciones-panel{
  justify-content: space-between !important;
}
</style>